import { STORE_ID, TYPES } from "./types";

const INITIAL_STATE = {

    item: {
        flagDivisaoComissao: false,
        nome: "",
        id: ""
    },
    copy: {},
    invalid: {
        flagDivisaoComissao: false,
        nome: false
    },
    permitions: {
        criar: false,
        deletar: false,
    },
    items: [],
    activeTab: "Search",
    seeRegister: false,
    activePersona: false
}

export default function tipoParceria(state = INITIAL_STATE, action) {
    switch (action.storeId) {
        case STORE_ID:
            switch (action.type) {
                case TYPES.SET_PERMITIONS:
                    return { ...state, permitions: action.value }
                case TYPES.SET_ITEMS:
                    return { ...state, items: action.value }
                case TYPES.SET_ITEM:
                    return { ...state, item: action.value }
                case TYPES.INVALID_TIPOPARCERIA:
                    return { ...state, invalid: { ...state.invalid, [action.field]: true } }
                case TYPES.CLEAN_INVALID_TIPOPARCERIA:
                    return { ...state, invalid: { ...state.invalid, [action.field]: false } }
                case TYPES.TIPOPARCERIA_COPY:
                    return { ...state, copy: action.value }
                case TYPES.CLEAN_REGISTER:
                    return {
                        ...state, item: {
                            ...state.item,
                            flagDivisaoComissao: false,
                            nome: "",
                            id: ""
                        },
                        invalid: INITIAL_STATE.invalid
                    }
                case TYPES.SET_ACTIVE_TAB:
                    return { ...state, activeTab: action.value }
                case TYPES.SET_SEE:
                    return { ...state, seeRegister: action.value }
                case TYPES.SET_PERSONA:
                    return { ...state, activePersona: action.value }
                default:
                    return { ...state }
            }
        default:
            return { ...state }
    }
}
